import {clientNotes, ClientNotes} from "./client-notes/ClientNotesComponent";
import {ClientNotesService} from "./client-notes/service/ClientNotesService";
import {clientNotesContent, ClientNotesContent} from "./content/ClientNotesContentComponent";
import {accountDetail, AccountDetail} from "./account-detail/AccountDetailComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;
    return angular.module(moduleName, [])
                  .component(AccountDetail, accountDetail())
                  .component(ClientNotes, clientNotes())
                  .component(ClientNotesContent, clientNotesContent())
                  .service(ClientNotesService.id, ClientNotesService)
                  .name;
}
